import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { IntegrationService } from '@tokeet-frontend/integrations'
import { isSomething } from '@tokeet/tv3-platform'
import { filter, take } from 'rxjs/operators'

@Component({
  selector: 'message-sent-with',
  templateUrl: './message-sent-with.component.html',
  styleUrls: ['./message-sent-with.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageSentWithComponent implements OnInit {
  @Input() set sentWith(sentWith: string) {
    if (this.isAppId(sentWith)) {
      this.integrationService
        .getAppInfo(sentWith)
        .pipe(filter(isSomething), take(1))
        .subscribe((app) => {
          this.sentWithString = app.name
          this.cd.detectChanges()
        })
    } else {
      this.sentWithString = sentWith
    }
  }
  @Input() platform: 'tokeet' | 'sympl'
  @Input() badgeType: 'info' | 'secondary' = 'info'

  sentWithString: string

  constructor(private integrationService: IntegrationService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}

  isAppId(id: string) {
    return /^app_/.test(id)
  }
}
